import { centerable, stylable } from '../decorators';
import { ALIGN_CLASSES_INVERSE } from '@intercom/embercom-prosemirror-composer/lib/blocks/constants';
export const paragraphSpec = stylable(centerable({
  inline: false,
  content: 'inline*',
  group: 'block',
  attrs: {
    type: {
      default: 'paragraph'
    }
  },
  parseDOM: [{
    tag: 'p',
    getAttrs(dom) {
      let alignment;
      // interblocks puts the alignment on the parent element
      if (dom.parentElement) {
        dom.parentElement.classList.forEach(className => {
          if (ALIGN_CLASSES_INVERSE[className]) {
            alignment = ALIGN_CLASSES_INVERSE[className];
          }
        });
      }
      return {
        alignment
      };
    }
  }],
  toDOM() {
    return ['p', 0];
  }
}));